import React from 'react'
import { makeStyles, Grid, Card } from '@material-ui/core'
import DisplayText from '../../../../../../../components_v1/Texts/DisplayText'
import RoundedButton from '../../../../../../../components_v1/Actions/RoundedButton'

const styles = makeStyles(theme => ({
    root: {
        marginBottom:32,
        borderRadius: 12,
        boxShadow: '0 10px 24px 0 rgba(82, 91, 115, .12)',
    },
    title: {
        color: theme.palette.primary.main,
        padding: '12px 32px',
        [theme.breakpoints.down('sm')]: {
            padding: 16,
        }
    },
    content: {
        padding: 32,
        [theme.breakpoints.down('sm')]: {
            padding: 16,
        }
    }
}))

const Banner = props => {

    const classes = styles()
    const { content, data, nodata, onEdit } = props

    return (
        <Card className={classes.root}>
            <div className={classes.title}>
                <Grid container>
                    <Grid item xs>
                        {content.title && (
                            <DisplayText variant='body2' align='left' style={{fontSize: 18, fontWeight: 500}}>
                                {content.title}
                            </DisplayText>
                        )}
                    </Grid>
                    <Grid item>
                        <RoundedButton onClick={onEdit} size='small'>{content.button}</RoundedButton>
                    </Grid>
                </Grid>
            </div>
            <div className={classes.content}>
                <Grid container justify='space-between' alignItems='center' spacing={2}>
                    {Object.keys(content.form).map((item, key) => {
                        return (
                            <Grid item key={key}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <DisplayText variant='subtitle2' color='textSecondary'>{content.form[item]}</DisplayText>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <DisplayText variant='body2'>{data[item] ? data[item] : nodata}</DisplayText>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    })}
                </Grid>
            </div>
        </Card>
    )
}

export default Banner